export default __webpack_public_path__ + "static/media/banco-del-pacifico.27c8dbdb.svg";